import React from 'react';
import PropTypes from 'prop-types';
import PanelClaro from 'newComponents/PanelClaro/PanelClaro';
import HeaderSection from './components/HeaderSection';
import InfoSection from './components/InfoSection';
import ButtonSection from './components/ButtonSection';

const Profile = ({
  label,
  className,
  form,
  errors,
  isEditMode,
  isSpecialUser,
  loading,
  onChange,
  onSave,
  onToggle,
}) => (
  <PanelClaro sectionName="micuentamodifyuser">
    <div className="row">
      <HeaderSection labelHeader={label.header} labelTitle={label.title} />

      <div className="col-xs-12 padding-top-1">
        <div className="row form-horizontal">
          <InfoSection
            name="username"
            placeholder={label.email}
            label={label.email}
            value={form.username}
          />

          <InfoSection
            name="firstname"
            placeholder={label.firstName}
            label={label.firstName}
            value={form.firstname}
            error={errors.firstname}
            editEnable={isEditMode}
            onChange={onChange}
          />

          <InfoSection
            name="lastname"
            placeholder={label.lastName}
            label={label.lastName}
            value={form.lastname}
            error={errors.lastname}
            editEnable={isEditMode}
            onChange={onChange}
          />
        </div>
      </div>

      <ButtonSection
        labelModify={label.modify}
        labelCancel={label.cancel}
        labelSave={label.save}
        classNameModify={className.modify}
        editEnable={isEditMode}
        isSpecialUser={isSpecialUser}
        loading={loading}
        onSave={onSave}
        onToggle={onToggle}
      />
    </div>
  </PanelClaro>
);

Profile.propTypes = {
  label: PropTypes.object,
  className: PropTypes.object,
  form: PropTypes.shape({
    username: PropTypes.string.isRequired,
    firstname: PropTypes.string.isRequired,
    lastname: PropTypes.string.isRequired,
  }),
  errors: PropTypes.object,
  loading: PropTypes.bool,
  isEditMode: PropTypes.bool,
  isSpecialUser: PropTypes.bool,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onToggle: PropTypes.func,
};
export default Profile;
